var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyJp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19172_48961)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#FA532E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1665 7.99984C6.1665 6.98732 6.98732 6.1665 7.99984 6.1665H13.3332C14.3457 6.1665 15.1665 6.98732 15.1665 7.99984V8.83317H15.9998C17.0124 8.83317 17.8332 9.65398 17.8332 10.6665V15.9998C17.8332 17.0124 17.0124 17.8332 15.9998 17.8332H10.6665C9.65398 17.8332 8.83317 17.0124 8.83317 15.9998V15.1665H7.99984C6.98732 15.1665 6.1665 14.3457 6.1665 13.3332V7.99984ZM9.83317 15.9998C9.83317 16.4601 10.2063 16.8332 10.6665 16.8332H15.9998C16.4601 16.8332 16.8332 16.4601 16.8332 15.9998V10.6665C16.8332 10.2063 16.4601 9.83317 15.9998 9.83317H10.6665C10.2063 9.83317 9.83317 10.2063 9.83317 10.6665V15.9998ZM14.1665 8.83317H10.6665C9.65398 8.83317 8.83317 9.65398 8.83317 10.6665V14.1665H7.99984C7.5396 14.1665 7.1665 13.7934 7.1665 13.3332V7.99984C7.1665 7.5396 7.5396 7.1665 7.99984 7.1665H13.3332C13.7934 7.1665 14.1665 7.5396 14.1665 7.99984V8.83317Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19172_48961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyJp);
export default __webpack_public_path__ + "static/media/copy-jp.a5610a25e5ed96427a56d54ebf51da52.svg";
export { ForwardRef as ReactComponent };